import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Card, CardContent } from "../components/ui/card";
import { toast } from "sonner";
import { Loader2, Monitor, Lock } from "lucide-react";
import axios from "axios";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_a6fd91e7-1ad0-4cf0-91ce-b769f9bab27a/artifacts/m0y29wqk_Sem%20T%C3%ADtulo.png";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function FactoryLogin() {
  const [userCode, setUserCode] = useState("");
  const [pin, setPin] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!userCode || !pin) {
      toast.error("Preencha todos os campos");
      return;
    }
    
    setLoading(true);
    try {
      const response = await axios.post(`${API}/auth/login`, {
        user_code: userCode,
        pin: pin,
      });
      
      const { token } = response.data;
      localStorage.setItem("mes_factory_token", token);
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      
      // Small delay to avoid DOM manipulation errors during navigation
      setTimeout(() => {
        navigate("/factory-display", { replace: true });
      }, 100);
    } catch (error) {
      toast.error(error.response?.data?.detail || "Credenciais inválidas");
    } finally {
      setLoading(false);
    }
  };

  const handlePinInput = (value) => {
    const numericValue = value.replace(/\D/g, "").slice(0, 6);
    setPin(numericValue);
  };

  return (
    <div 
      className="min-h-screen flex flex-col items-center justify-center p-8"
      style={{
        background: "linear-gradient(135deg, #1e3a5f 0%, #0d1b2a 50%, #1b263b 100%)"
      }}
      data-testid="factory-login-page"
    >
      {/* Logo */}
      <div className="mb-8">
        <div className="bg-white rounded-xl p-4 inline-block shadow-2xl">
          <img 
            src={LOGO_URL} 
            alt="EP3D Engineering Project" 
            className="h-24 md:h-32 object-contain"
          />
        </div>
      </div>

      <Card className="w-full max-w-md bg-white/95 backdrop-blur-sm shadow-2xl border-0">
        <CardContent className="pt-8 pb-8 px-8">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-amber-400 to-amber-600 mb-4">
              <Monitor className="h-8 w-8 text-white" />
            </div>
            <h1 className="text-2xl font-bold text-gray-800">Ecrã de Fábrica</h1>
            <p className="text-gray-500 mt-2">Acesso ao painel de produção</p>
          </div>

          <form onSubmit={handleLogin} className="space-y-6">
            <div className="space-y-2">
              <label className="text-sm font-medium text-gray-700">
                Código de Utilizador
              </label>
              <Input
                value={userCode}
                onChange={(e) => setUserCode(e.target.value.toUpperCase())}
                placeholder="Ex: ADMIN"
                className="h-12 text-lg font-mono text-center tracking-wider border-2 focus:border-amber-500"
                data-testid="factory-user-code"
              />
            </div>

            <div className="space-y-2">
              <label className="text-sm font-medium text-gray-700">
                PIN
              </label>
              <div className="relative">
                <Input
                  type="password"
                  value={pin}
                  onChange={(e) => handlePinInput(e.target.value)}
                  placeholder="••••••"
                  className="h-12 text-lg font-mono text-center tracking-[0.5em] border-2 focus:border-amber-500"
                  maxLength={6}
                  data-testid="factory-pin"
                />
                <Lock className="absolute right-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400" />
              </div>
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full h-14 text-lg font-bold bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 shadow-lg"
              data-testid="factory-login-btn"
            >
              {loading ? (
                <>
                  <Loader2 className="mr-2 h-5 w-5 animate-spin" />
                  A verificar...
                </>
              ) : (
                <>
                  <Monitor className="mr-2 h-5 w-5" />
                  Aceder ao Ecrã de Fábrica
                </>
              )}
            </Button>
          </form>
        </CardContent>
      </Card>

      <p className="mt-6 text-white/50 text-sm">
        EP3D ENGINEERING PROJECT © {new Date().getFullYear()}
      </p>
    </div>
  );
}
